import React, { Component } from "react";
import { Row, Col, Table, Drawer, Badge } from "antd";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import "./Result.css";
import ButtonLinkIcon from "../../Components/MyComponent/ButtonLinkIcon";
import ExportExcel from "../../Components/ExportExcel/ExportExcel";
import { API } from "../../API/API";
import Search from "../../Components/Search/Search";
const forExcelCol = [
  {
    title: "Код",
    dataIndex: "invitationcode",
  },
  {
    title: "Урилгын нэр",
    dataIndex: "tendername",
  },
  {
    title: "Захиалагч",
    dataIndex: "departmentname",
  },
  {
    title: "Төрөл",
    dataIndex: "tendertypename",
  },
  {
    title: "ХАА-ын арга",
    dataIndex: "purchasetypename",
  },
  {
    title: "Тендер нийтлэх хугацаа",
    dataIndex: "publishdate",
  },
  {
    title: "Хүлээн авах хугацаа",
    dataIndex: "acceptdate",
  },
  {
    title: "Тендер нээх хугацаа",
    dataIndex: "opendate",
  },
  {
    title: "Төлөв",
    dataIndex: "status",
  },
];
class ResultList extends Component {
  state = {
    data: [],
    showInputForm: false,
    clarificationTitle: "",
    selectedInvitationID: 0,
    sortedInfo: null,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getInvitationListResult").then((response) => {
      if (response.status === 200) {
        console.log(response.data.retData);
        this.setState({
          data: response.data.retData,
          dataFilter: response.data.retData,
        });
      }
    });
  };
  showInputFormHandler = (show, title, invid) => {
    this.setState({
      showInputForm: show,
      clarificationTitle: "Захиа - " + title,
      selectedInvitationID: invid,
    });
  };
  onSearch = (pvalue) => {
    let tTableData = [...this.state.data];
    if (pvalue) {
      tTableData = tTableData.filter((r) => {
        if (
          String(r.invitationcode)
            .toLowerCase()
            .indexOf(pvalue.toString().toLowerCase()) >= 0 ||
          String(r.tendername)
            .toLowerCase()
            .indexOf(pvalue.toString().toLowerCase()) >= 0 ||
          String(r.departmentname)
            .toLowerCase()
            .indexOf(pvalue.toString().toLowerCase()) >= 0 ||
          String(r.tendertypename)
            .toLowerCase()
            .indexOf(pvalue.toString().toLowerCase()) >= 0 ||
          String(r.purchasetypename)
            .toLowerCase()
            .indexOf(pvalue.toString().toLowerCase()) >= 0 ||
          String(r.status)
            .toLowerCase()
            .indexOf(pvalue.toString().toLowerCase()) >= 0 ||
          String(r.opendate)
            .toLowerCase()
            .indexOf(pvalue.toString().toLowerCase()) >= 0 ||
          String(r.acceptdate)
            .toLowerCase()
            .indexOf(pvalue.toString().toLowerCase()) >= 0
        ) {
          return true;
        } else {
          return false;
        }
      });
    } else {
      tTableData = [...this.state.data];
    }
    this.setState({ dataFilter: tTableData });
  };
  handleChange = (pagination, filters, sorter) => {
    this.setState({
      sortedInfo: sorter,
    });
  };
  render() {
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};
    const columns = [
      {
        title: "Код",
        dataIndex: "invitationcode",
        key: "invitationcode",
        width: "10%",
        align: "left",
        sorter: (a, b) =>
          a.invitationcode
            ? a.invitationcode.localeCompare(b.invitationcode)
            : null,
        sortOrder:
          sortedInfo.columnKey === "invitationcode" && sortedInfo.order,
        render: (text, record) => {
          return (
            <Link
              style={{ fontWeight: "500", color: "#0358A7" }}
              key={record.invitationid}
              to={
                "/invitation/" +
                record.invitationid +
                "/" +
                record.tenderid +
                "/" +
                record.tendername +
                "/" +
                record.departmentname +
                "/" +
                record.tendertypename +
                "/" +
                record.purchasetypename +
                "/" +
                record.budget +
                "/0/" +
                this.props.opening
              }
            >
              {record.invitationcode}
            </Link>
          );
        },
      },
      {
        title: "Урилгын нэр",
        dataIndex: "tendername",
        key: "tendername",
        width: "20%",
        align: "left",
        sorter: (a, b) =>
          a.tendername ? a.tendername.localeCompare(b.tendername) : null,
        sortOrder: sortedInfo.columnKey === "tendername" && sortedInfo.order,
      },
      {
        title: "Захиалагч",
        dataIndex: "departmentname",
        key: "departmentname",
        width: "17%",
        align: "left",
        sorter: (a, b) =>
          a.departmentname
            ? a.departmentname.localeCompare(b.departmentname)
            : null,
        sortOrder:
          sortedInfo.columnKey === "departmentname" && sortedInfo.order,
      },
      {
        title: "Төрөл",
        dataIndex: "tendertypename",
        key: "tendertypename",
        width: "10%",
        align: "left",
        sorter: (a, b) =>
          a.tendertypename
            ? a.tendertypename.localeCompare(b.tendertypename)
            : null,
        sortOrder:
          sortedInfo.columnKey === "tendertypename" && sortedInfo.order,
      },
      {
        title: "ХАА-ын арга",
        dataIndex: "purchasetypename",
        key: "purchasetypename",
        width: "10%",
        align: "left",
        sorter: (a, b) =>
          a.purchasetypename
            ? a.purchasetypename.localeCompare(b.purchasetypename)
            : null,
        sortOrder:
          sortedInfo.columnKey === "purchasetypename" && sortedInfo.order,
      },
      {
        title: "Хүлээн авах хугацаа",
        dataIndex: "acceptdate",
        key: "acceptdate",
        width: "10%",
        align: "left",
      },
      {
        title: "Тендер нээх хугацаа",
        dataIndex: "opendate",
        key: "opendate",
        width: "10%",
        align: "left",
      },
      {
        title: "Ирүүлсэн",
        dataIndex: "recieved",
        key: "recieved",
        width: "10%",
        align: "left",
      },
      {
        title: "Төлөв",
        dataIndex: "status",
        key: "status",
        width: "12%",
        align: "left",
        render: (text, record) => {
          return (
            <div style={{ color: record.isselect > 0 ? "#298304" : "black" }}>
              {record.status}
            </div>
          );
        },
      },
    ];
    return (
      <div className="Container">
        <Row align="middle">
          <Col span={12}>
            <Row style={{ height: 56 }} justify="start" align="middle">
              <Col>
                <div className="HeaderLabel">Нээлтийн жагсаалт</div>
              </Col>
              <Col>
                <div className="divider"></div>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row
              style={{ height: 56 }}
              justify="end"
              align="middle"
              gutter={[16, 16]}
            >
              <Col>
                <Search
                  search={(value) => this.onSearch(value)}
                  placeholder="Хайх..."
                ></Search>
              </Col>
              <Col style={{ marginRight: 10 }}>
                <ExportExcel
                  fileName={"Нээлтийн жагсаалт"}
                  column={forExcelCol}
                  dataSource={this.state.data}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <div id="result-list" style={{ marginRight: 15 }}>
          <Table
            dataSource={this.state.dataFilter}
            onChange={this.handleChange}
            columns={[
              {
                title: "№",
                dataIndex: "key",
                key: "key",
                width: "3%",
                render: (text, row, index) => (
                  <>{this.state.data.indexOf(row) + 1}</>
                ),
              },
              ...columns,
            ]}
            scroll={{ y: 500 }}
            pagination={false}
            rowKey="invitationid"
          />
        </div>
      </div>
    );
  }
}

export default withRouter(ResultList);
